export default __webpack_public_path__ + "static/media/linkedin.69f2aa5b.png";